import React from "react";
import { connect } from "formik";
import TabSelector from "venuescanner-js/react/components/TabSelector";
import stage3Classes from "../../styles/corpOrPrivate.module.scss";
import { FormikShape } from "venuescanner-js/react/components/shapes";

const opts = {
  "Personal Event": false,
  "Business Event": true,
};

export const EVENT_TYPE_FIELD_NAME = "eventType";
export const FIELD_NAME = "isCorporate";

export const CorporateOrPrivateRadio = ({
  formik: { values, setFieldValue },
}) => {
  const value = values[FIELD_NAME];
  const isCorporate = values[EVENT_TYPE_FIELD_NAME]?.isCorporate;
  React.useEffect(() => {
    if (typeof value === "undefined") setFieldValue(FIELD_NAME, isCorporate);
  }, [setFieldValue, value, isCorporate]);

  return (
    <TabSelector
      name={FIELD_NAME}
      options={opts}
      value={value}
      onChange={(val) => {
        window.dataLayer.push({ event: FIELD_NAME });
        setFieldValue(FIELD_NAME, val);
      }}
      className={stage3Classes.CorporateRadio}
    />
  );
};

CorporateOrPrivateRadio.propTypes = {
  formik: FormikShape.isRequired,
};

export default connect(CorporateOrPrivateRadio);
